import { BeesafeAssistanceCoverage } from './beesafe-coverage-comparison-dialog.component';

export class BeesafeAssistanceCoveragesComparisonConfig {

    private readonly translationsContainerKey = 'ASSISTANCE_COVERAGES_COMPARISON';

    constructor() {}

    createConfig(): BeesafeAssistanceCoverageConfig[] {
        return [
            {
                coverageName: BeesafeAssistanceCoverageName.PACKAGE_NAME,
                none: `${this.translationsContainerKey}.PACKAGE_NAME.none`,
                mini: `${this.translationsContainerKey}.PACKAGE_NAME.mini`,
                basic: `${this.translationsContainerKey}.PACKAGE_NAME.basic`,
                standard: `${this.translationsContainerKey}.PACKAGE_NAME.standard`,
                premium: `${this.translationsContainerKey}.PACKAGE_NAME.premium`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.TERRITORIAL_RANGE,
                none: false,
                mini: `${this.translationsContainerKey}.TERRITORIAL_RANGE.poland`,
                basic: `${this.translationsContainerKey}.TERRITORIAL_RANGE.polandAndEurope`,
                standard: `${this.translationsContainerKey}.TERRITORIAL_RANGE.polandAndEurope`,
                premium: `${this.translationsContainerKey}.TERRITORIAL_RANGE.polandAndEurope`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_HAPPENING,
                none: false,
                mini: `${this.translationsContainerKey}.ASSISTANCE_HAPPENING.accidentBreakdownTheft`,
                basic: `${this.translationsContainerKey}.ASSISTANCE_HAPPENING.accidentBreakdownTheft`,
                standard: `${this.translationsContainerKey}.ASSISTANCE_HAPPENING.accidentBreakdownTheft`,
                premium: `${this.translationsContainerKey}.ASSISTANCE_HAPPENING.accidentBreakdownTheft`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_TOWING_ACCIDENT_PL,
                none: false,
                mini: `${this.translationsContainerKey}.ASSISTANCE_TOWING.nearWorkshop150km`,
                basic: `${this.translationsContainerKey}.ASSISTANCE_TOWING.nearWorkshop`,
                standard: `${this.translationsContainerKey}.ASSISTANCE_TOWING.200km`,
                premium: `${this.translationsContainerKey}.ASSISTANCE_TOWING.1000km`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_TOWING_BREAKDOWN_PL,
                none: false,
                mini: false,
                basic: false,
                standard: `${this.translationsContainerKey}.ASSISTANCE_TOWING.200km`,
                premium: `${this.translationsContainerKey}.ASSISTANCE_TOWING.1000km`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_TOWING_EU,
                none: false,
                mini: false,
                basic: `${this.translationsContainerKey}.ASSISTANCE_TOWING.nearWorkshop`,
                standard: `${this.translationsContainerKey}.ASSISTANCE_TOWING.200km`,
                premium: `${this.translationsContainerKey}.ASSISTANCE_TOWING.1000km`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_ACCIDENT_REPLACEMENT_CAR,
                none: false,
                mini: false,
                basic: `${this.translationsContainerKey}.ASSISTANCE_REPLACEMENT_CAR.3days`,
                standard: `${this.translationsContainerKey}.ASSISTANCE_REPLACEMENT_CAR.5days`,
                premium: `${this.translationsContainerKey}.ASSISTANCE_REPLACEMENT_CAR.14days`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_BREAKDOWN_REPLACEMENT_CAR,
                none: false,
                mini: false,
                basic: `${this.translationsContainerKey}.ASSISTANCE_REPLACEMENT_CAR.3days`,
                standard: `${this.translationsContainerKey}.ASSISTANCE_REPLACEMENT_CAR.3days`,
                premium: `${this.translationsContainerKey}.ASSISTANCE_REPLACEMENT_CAR.14days`
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_REPLACEMENT_OF_WHEELS,
                none: false,
                mini: false,
                basic: false,
                standard: true,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_FUEL,
                none: false,
                mini: false,
                basic: false,
                standard: true,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_REPAIR_PARTS,
                none: false,
                mini: false,
                basic: false,
                standard: true,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_ACCIDENT_HOSPITALIZATION,
                none: false,
                mini: false,
                basic: false,
                standard: false,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_LEGAL_PROTECTION_ABROAD,
                none: false,
                mini: false,
                basic: false,
                standard: true,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_BATTERY,
                none: false,
                mini: false,
                basic: false,
                standard: true,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_KEYS,
                none: false,
                mini: false,
                basic: false,
                standard: true,
                premium: true
            },
            {
                coverageName: BeesafeAssistanceCoverageName.ASSISTANCE_VEHICLE_SCRAPPING,
                none: false,
                mini: false,
                basic: false,
                standard: false,
                premium: true
            }
        ]
    }

}

export interface BeesafeAssistanceCoverageConfig {
    coverageName: BeesafeAssistanceCoverageName;
    none?: string | boolean;
    mini: string | boolean;
    basic: string | boolean;
    standard: string | boolean;
    premium: string | boolean;
}

export interface AssistanceCoverageVariantPricing {
    name: BeesafeAssistanceCoverage;
    price: number;
}

export enum BeesafeAssistanceCoverageName {
    PACKAGE_NAME = 'PACKAGE_NAME',
    TERRITORIAL_RANGE = 'TERRITORIAL_RANGE',
    ASSISTANCE_HAPPENING = 'ASSISTANCE_HAPPENING',
    ASSISTANCE_DISTANCE_HELP = 'ASSISTANCE_DISTANCE_HELP',
    ASSISTANCE_TOWING_ACCIDENT_PL = 'ASSISTANCE_TOWING_ACCIDENT_PL',
    ASSISTANCE_TOWING_BREAKDOWN_PL = 'ASSISTANCE_TOWING_BREAKDOWN_PL',
    ASSISTANCE_TOWING_EU = 'ASSISTANCE_TOWING_EU',
    ASSISTANCE_ACCIDENT_REPLACEMENT_CAR = 'ASSISTANCE_ACCIDENT_REPLACEMENT_CAR',
    ASSISTANCE_BREAKDOWN_REPLACEMENT_CAR = 'ASSISTANCE_BREAKDOWN_REPLACEMENT_CAR',
    ASSISTANCE_REPLACEMENT_OF_WHEELS = 'ASSISTANCE_REPLACEMENT_OF_WHEELS',
    ASSISTANCE_FUEL = 'ASSISTANCE_FUEL',
    ASSISTANCE_BATTERY = 'ASSISTANCE_BATTERY',
    ASSISTANCE_KEYS = 'ASSISTANCE_KEYS',
    ASSISTANCE_REPAIR_PARTS = 'ASSISTANCE_REPAIR_PARTS',
    ASSISTANCE_ACCIDENT_HOSPITALIZATION = 'ASSISTANCE_ACCIDENT_HOSPITALIZATION',
    ASSISTANCE_LEGAL_PROTECTION_ABROAD = 'ASSISTANCE_LEGAL_PROTECTION_ABROAD',
    ASSISTANCE_VEHICLE_SCRAPPING = 'ASSISTANCE_VEHICLE_SCRAPPING',
}
